<template>
  <div class="topic-detail-data-relation">
    <div class="table-bd">
      <custom-table :data="data" :column="tableColumn" height="100%" @filter="filterChange" @sort="sortChange"></custom-table>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable.vue';

export default {
  components: {
    customTable,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tableCode: 'topic_detail_data_relation',
    };
  },
  mounted() {
    this.getTableColumn();
  },
};
</script>

<style lang="scss">
.topic-detail-data-relation {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 15px;
  .el-table {
  }
}
</style>
